import api from "./api";

export default async function getModules() {
  try {
    const response = await api.get("/settings/findLimited");

    if (response.data) {
      const modulesConfig =
        response.data.find((s) => s.produto === "modulos")?.configuracoes || {};
      return modulesConfig;
    } else {
      return {};
    }
  } catch (error) {}
  return {};
}
